<p class="maquette-statique">configuration works!</p>
